export const publicKey_url = 'https://uat-js.adapid.link/js/publicKey.pem'
export const login_url = 'https://uat-api.adapid.link/api/v4/admin/login/'
export const intruderinfo_url = 'https://uat-api.adapid.link/api/v4/intruderinfo/?'
export const incident_url = 'https://uat-api.adapid.link/api/v4/incidentdetail/'
export const admin_list = 'https://uat-api.adapid.link/api/v4/admin/list/'
export const tenant_list = 'https://uat-api.adapid.link/api/v4/admin/tenantlist/'
export const create_admin = 'https://uat-api.adapid.link/api/v4/admin/create/'
export const tenant_onboard = 'https://uat-api.adapid.link/api/v4/admin/onboard/'

// export const publicKey_url = 'https://uat-js.adapid.link/js/publicKey.pem'
// export const login_url = 'https://uat.adapid.link/api/v1/dashboard/admin/login'
// export const intruderinfo_url = 'https://uat.adapid.link/api/v1/dashboard/intruderinfo/?'
// export const incident_url = 'https://uat.adapid.link/api/v1/dashboard/incidentdetails'
// export const admin_list = 'https://uat.adapid.link/api/v1/dashboard/admin/list'
// export const tenant_list = 'https://uat.adapid.link/api/v1/dashboard/admin/tenantlist'
// export const create_admin = 'https://uat.adapid.link/api/v1/dashboard/admin/create'
// export const tenant_onboard = 'https://uat.adapid.link/api/v1/dashboard/admin/onboard'



